import { PostSearchResultsSectionWeb } from '@nucleus/types/web/sections/post-search-results';
import { useSection } from '@nucleus/web-theme';
import { nucleusClass } from '@nucleus/web-theme-elements';
import classNames from 'classnames';
import React from 'react';
import { getSectionClasses } from '../../lib/classes';
import { Section } from '../../sectionLayouts/Section';
import { SectionLayout } from '../../sectionLayouts/SectionLayout';
import { PostSearchResultsBlockLayoutContentOnly } from './PostSearchResultsBlockLayoutContentOnly';

export const PostSearchResultsSection = (): JSX.Element => {
  const section = useSection<PostSearchResultsSectionWeb>();

  return (
    <Section className={classNames(nucleusClass('section-search-result'), getSectionClasses(section))}>
      <SectionLayout {...section.payload}>
        <PostSearchResultsBlockLayoutContentOnly {...section.payload} />
      </SectionLayout>
    </Section>
  );
};
